import { render, staticRenderFns } from "./RecordPropertyDetailSummary.vue?vue&type=template&id=b006fe76&scoped=true&"
import script from "./RecordPropertyDetailSummary.vue?vue&type=script&lang=js&"
export * from "./RecordPropertyDetailSummary.vue?vue&type=script&lang=js&"
import style0 from "./RecordPropertyDetailSummary.vue?vue&type=style&index=0&id=b006fe76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b006fe76",
  null
  
)

export default component.exports